export enum ProjectDetailsTab {
  SETTINGS = 'settings',
  SUPPLIERS = 'suppliers',
  UPLOADS = 'uploads',
  DOCUMENTS = 'documents',
  IBL = 'ibl',
}
